import { RegisterRequest, RegisterResponse } from '../register';
import * as _m0 from "protobufjs/minimal";

export async function register(request: RegisterRequest): Promise<RegisterResponse> {
    const encodedRequest = RegisterRequest.encode(request).finish();
    const base64 = _m0.util.base64.encode(encodedRequest, 0, encodedRequest.length);

    const params = new URLSearchParams(window.location.search);
    const staging = params.get('stagingEnv') === 'true';

    let url = "https://api.precisca.ai/authservice/register";
    if (staging) {
        url = `${url}-staging`;
    }

    const response = await fetch(
        url, {
        method: 'POST',
        headers: {
        },
        credentials: 'include', // Necessary to accept and store the HttpOnly cookie
        body: base64
    }
    );

    if (response.status !== 200) {
        throw new Error(`Unable to register! Status: ${response.status}`);
    }

    const encodedByteString = await response.text();

    const decodedByteString = atob(encodedByteString);
    const decodedBytes = new Uint8Array(decodedByteString.length);
    for (let i = 0; i < decodedByteString.length; i++) {
        decodedBytes[i] = decodedByteString.charCodeAt(i);
    }

    return RegisterResponse.decode(decodedBytes);
}
